import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent } from "primeng/api";
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-kyc-list',
  templateUrl: './user-kyc-list.component.html',
  styleUrls: ['./user-kyc-list.component.scss']
})
export class UserKycListComponent implements OnInit {
  public loggedInUser;
  public isLoggedIn: boolean = false;
  public userId;
  loading: boolean;
  kycData: any;
  totalRecords: 0;

  constructor(
    private userService: UserService,
    private tokenStorage: TokenStorageService,
    private router: Router,


  ) {}

  ngOnInit(): void {
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }
  }
  loadUserKyc(event: LazyLoadEvent) {
    var query = "?filterDisable=false&filterByuserId=" + this.userId;
    this.userService.getUserKycDetailsList(query).subscribe(
      (data) => {
        this.loading = false;
        this.kycData = data.items;
        this.totalRecords = data.totalCount;
      }
    );
  }
}
